// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ViewRef, ElementRef, HostListener, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// NGRX
// Service
//Models
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { DatePipe } from '@angular/common';
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';


@Component({
	selector: 'kt-dnxk-noi-bo-171123',
	templateUrl: './dnxk-noi-bo-171123.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})


export class DNXKNoiBo171123PrintComponent implements OnInit {
	dataPBDNOnly: any = [];
	dataPBSDOnly: any = [];
	dataBPSDOnly: any = [];
	details: any = [];

	@Input() masterData: any;
	@Input() set detailData(data) {
		if (!data) return;
		data.forEach(item => {
			if (!this.dataPBDNOnly.includes(item.TenBPDN))
				this.dataPBDNOnly.push(item.TenBPDN);
			if (!this.dataPBSDOnly.includes(item.TenBPSD))
				this.dataPBSDOnly.push(item.TenBPSD);
			if (!this.dataBPSDOnly.includes(item.NameNewBPSD))
				this.dataBPSDOnly.push(item.NameNewBPSD);
		});
		this.details = data;
	}
	now = new Date();
	
	constructor(
		private datePipe: DatePipe) {};
		
	/**
	 * On init
	 */
	ngOnInit() {
	}
	
	// .. Function dùng chung mặc định
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	// ................................

	// .. Tính tổng số lượng | Không phân biệt đơn vị
	sumQuantities(){
		var totalQuantity = 0;
		this.details.forEach(item => {
			totalQuantity += item.SoLuongQuiDoi;
		})
		return this.f_number(totalQuantity);
	}
	// ...............................................
}
